import { Permission } from '../permission.types'
import { Role } from '../../store/interfaces/role'

/**
 * Resolves permissions from `Role.permissionsJson` for the modern API model.
 * Until the backend populates this field, returns an empty set (passthrough in PermissionService).
 */
export function permissionsFromRolesJson(roles: Role[]): Set<Permission> {
  const result = new Set<Permission>()

  for (const role of roles) {
    const json = role.permissionsJson
    if (!json) continue

    const list = Array.isArray(json) ? json : json.permissions
    if (!Array.isArray(list)) continue

    for (const entry of list) {
      const value = typeof entry === 'string' ? entry : entry?.key
      if (value && Object.values(Permission).includes(value as Permission)) {
        result.add(value as Permission)
      }
    }
  }

  return result
}
